<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">PPPoE Plus Config</div> 
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the config of PPPoE Plus." }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--global config-->
        <pane label="Global">
          <pppoeplus-global></pppoeplus-global>
        </pane>
        <!--interface config-->
        <pane label="Interface">
          <pppoeplus-interface></pppoeplus-interface>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs.vue"
import Pane from "@/components/Pane.vue"
import PppoeplusGlobal from "@/views/PppoeplusGlobalConfig.vue"
import PppoeplusInterface from "@/views/PppoeplusPortConfig.vue"

export default {
  components: {
    Tabs,
    Pane,
    PppoeplusGlobal,
    PppoeplusInterface,
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
}
</script>

